import { Button } from '@/components/ui/button';
import { getGoogleAuthConnectURLMutation } from '@/mutations/auth/getGoogleAuthConnectURLMutation';
import { SiGoogle } from '@icons-pack/react-simple-icons';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type LoginOrSignupWithProps = {
  type: 'login' | 'signup';
  invitationFlow?: {
    organizationId?: string;
    invitationCode?: string;
  };
  redirect?: string;
};

export function LoginOrSignupWith({
  type,
  invitationFlow,
  redirect,
}: LoginOrSignupWithProps) {
  const { t } = useTranslation();

  const { mutate: getGoogleAuthConnectURL, isPending } = useMutation({
    ...getGoogleAuthConnectURLMutation(),
    onSuccess: (data) => {
      window.location.href = data.value.url;
    },
  });

  return (
    <>
      <Button
        variant="outline"
        className="w-full"
        onClick={() => getGoogleAuthConnectURL({ ...invitationFlow, redirect })}
        isLoading={isPending}
        icon={<SiGoogle />}
      >
        {t(`auth.loginOrSignupWith.${type}WithGoogle`)}
      </Button>

      {/* Separator with 'or' */}
      <div className="flex items-center my-4">
        <div className="flex-grow h-px bg-gray-200" />
        <span className="mx-3 text-gray-400 text-sm font-medium">
          {t('auth.loginOrSignupWith.or')}
        </span>
        <div className="flex-grow h-px bg-gray-200" />
      </div>
    </>
  );
}
